import { formData, authApi } from "utils";

export const savePayments = (settings, data) => () => {

    let config = {};
    if(config) {
        config = { onUploadProgress: data.onUploadProgress }
    }

    return authApi.post(`/settings/shop/payments`, formData(settings), config).then(res => {
        if (res.status === 200) {
            return res
        } else {
            throw res
        }
    }).catch(err => {
        throw err
    })
}
